import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicCurrencyPipe } from './pipes/dynamic-currency.pipe';
import { SubscriptionTermsDaysFrequencyPipe } from './pipes/subscription-terms-days-frequency.pipe';
import { UnitsSoldFormatPipe } from './pipes/units-sold-format.pipe';

@NgModule({
  declarations: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe,UnitsSoldFormatPipe],
  exports: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe,UnitsSoldFormatPipe],
  imports: [CommonModule],
  providers: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe,UnitsSoldFormatPipe] 
})
export class SharedModule {}